import Joi from 'joi'

export const commissionReportSchema = Joi.object({
  start: Joi.allow(),
  end: Joi.allow(),
  categories: Joi.allow(),
  partnerId: Joi.allow(),
  employeeId: Joi.allow()
})
